import { Icon } from '@mui/material';
import MDButton from 'components/MDButton';
import React, { useEffect, useState } from 'react'
import { deleteContactUs, getContactUs } from './../../api/routes';
import { toast } from "react-toastify";

export default function ContactUs() {
    const [contactUsData, setContactUsData] = useState([]);

    useEffect(() => {
        getContactUs((isOk, data) => {
            if (!isOk) return toast.error(data.message);
            else return setContactUsData(data)
        })
    }, [])

    const removeContactUs = (contactusId) => {
        deleteContactUs(contactusId, (isOk, data) => {
            if (!isOk) return toast.error(data.message);

            else return window.location.reload()
        })
    }

    return (
        <div style={{ margin: '1rem 0' }}>
            {contactUsData.map(data => <section key={data.contactusId} style={{ fontSize: '1rem', borderRadius: '8px', display: 'flex', flexDirection: 'column', minHeight: '60px', marginTop: '1rem', padding: '1rem', border: '1px solid #d2d6da' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <p style={{ color: '#00000099' }}>نام و نام خانوادگی : <span style={{ color: '#010101' }}>{data.fullname}</span></p>
                    <p style={{ color: '#00000099' }}>شماره تماس یا ایمیل: <span style={{ color: '#010101' }}>{data.phoneNumberOrEmail}</span></p>
                    <MDButton variant="text" color="error" onClick={() => removeContactUs(data.contactusId)}>
                        <Icon>delete</Icon>
                    </MDButton>
                </div>
                <p style={{ color: '#00000099', marginTop: '1rem' }}>متن پیام : <span style={{ color: '#010101', fontSize: '14px' }}>{data.text}</span></p>
            </section>)}
        </div>
    )
}
